import { useSelector } from "react-redux";
import classes from "./HotMap.module.css"
import MapLegend from "./HotMapHeader/MapLegend";
import { useState } from "react";
import HotMapTable from "./HotMapTable/HotMapTable";
import DownloadExel from "./HotMapHeader/DownloadExel";

const HotMap = ({ studentsSubmmissionList }) => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);
    const [msg, setMsg] = useState()


    return (
        <div>
            <div className={`${classes.StudentsLayoutContainer}`}>
                <div className={`${classes.StudentsLayoutWrap}  ${classes[direction]}`} >
                    <div className={classes.Header}>
                        <div className={classes.AchievementsTitle}>
                            <div className={classes.AchievementsText}>{texts.Achievements}</div>
                            <div className={classes.AchievementsIcon}></div>
                        </div>
                        <MapLegend></MapLegend>
                        <DownloadExel studentsSubmmissionList={studentsSubmmissionList} setMsg={setMsg}></DownloadExel>
                    </div>
                    <HotMapTable studentsSubmmissionList={studentsSubmmissionList}></HotMapTable>
                    {msg}
                </div>
            </div>
        </div>
    )
}
export default HotMap